import { takeLatest, put, call } from 'redux-saga/effects';

import { restClient } from 'config/store/configureStore';

import * as actions from './actions';
import * as actionTypes from './actionTypes';

/** @param {import('./types').SubscribeIntegrationAction} */
function* subscribeIntegration({ payload: { request, dealerId }, meta }) {
  try {
    yield call(restClient.request, request);
    yield put(actions.subscribeIntegrationSuccess(dealerId, meta));
  } catch (error) {
    yield put(actions.subscribeIntegrationFailure(error, meta));
  }
}

export default function* saga() {
  yield takeLatest(actionTypes.SUBSCRIBE_INTEGRATION, subscribeIntegration);
}
